<template>
  <a-card title="文件管理助手" :bodyStyle="{padding:0}" >
    <template #extra>
        <span style="color: #999;">仅显示近1天的下载任务　</span>
      </template>
    <a-table row-key="id" style="width:520px" :loading="loading" :pagination="false" :data="renderList" :scroll="scroll" size="small">
        <template #columns>
          <a-table-column title="文件名" data-index="taskName" tooltip ellipsis/>
          <a-table-column title="开始时间" data-index="startTime" :width="180" />
          <a-table-column title="状态" data-index="state" :width="90">
            <template #cell="{ record }">
                <span v-if="record.state == 1" class="circle pass"></span>
              <span v-else class="circle ready"></span>
              <span>{{ record.state == 1 ? "已生成" : "生成中" }}</span>
            </template>
          </a-table-column>
          <a-table-column title="操作" :width="80" align="center">
            <template #cell="{ record }">
              <a-button type="text" v-show="record.state == 1" size="small" @click="download(record.url)"> 下载 </a-button>
            </template>
          </a-table-column>
        </template>
      </a-table>
  </a-card>
</template>

<script lang="ts" setup>
import { ref, reactive, toRefs, computed } from "vue";
import { API } from "@/api/setting";
import useLoading from "@/hooks/loading";
import { downloadFile } from "@/utils/util";
//   import List from './list.vue';
import { useIntervalFn } from '@vueuse/core'
interface TabItem {
  key: string;
  title: string;
  avatar?: string;
}
const { loading, setLoading } = useLoading(true);
const renderList = ref([]);
const scroll = {
  y: 200,
  x: 500,
};
async function fetchSourceData() {
  setLoading(true);
  try {
    const { data } = await API.queryDownloadFile({});
    console.log(data);
    renderList.value = data;
  } catch (err) {
    // you can report use errorHandler or other
  } finally {
    setLoading(false);
  }
}
const download = (url) => {
  downloadFile(url);
};
fetchSourceData();
const { pause, resume, isActive } = useIntervalFn(() => {
  fetchSourceData();
}, 5000)
</script>

<style scoped lang="less">
:deep(.arco-popover-popup-content) {
  padding: 0;
}

:deep(.arco-list-item-meta) {
  align-items: flex-start;
}
:deep(.arco-tabs-nav) {
  padding: 14px 0 12px 16px;
  border-bottom: 1px solid var(--color-neutral-3);
}
:deep(.arco-tabs-content) {
  padding-top: 0;
  .arco-result-subtitle {
    color: rgb(var(--gray-6));
  }
}
</style>